export enum PaymentMethodEnum {
  Cash = 1,
  CreditCard = 2,
  Credits = 4,
  //...
  Square = 14,
  //...
  ePay = 27,
}
